<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="iconWidth"
    :height="iconHeight"
    viewBox="0 0 25 25"
    :aria-labelledby="`icon-${name}`"
    role="presentation"
    :style="styleObj"
  >
    <g>
      <component :is="`icon-${name}`" />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'Icon',
  props: {
    width: { type: [String, Number], default: 20 },
    height: { type: [String, Number], default: 20 },
    size: { type: [String, Number], default: 20 },
    name: { type: String, required: true },
    color: { type: String, default: 'purple' },
  },
  computed: {
    iconWidth() {
      return this.size ? this.size : this.width
    },
    iconHeight() {
      return this.size ? this.size : this.height
    },
    styleObj() {
      return {
        '--icon-color': `var(--${this.color})`,
      }
    },
  },
}
</script>
<style scoped lang="scss">
svg {
  fill: $color-brand-primary;
  transition: all 200ms ease;
}

svg:hover {
  fill: $color-feedback-positive;
}
</style>
